import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const PropostaIndex = Loadable({
  loader: () => import('../views/Proposta'),
  loading: RouteLoading,
});

const PropostaDashboard = Loadable({
  loader: () => import('../views/Proposta/Dashboard'),
  loading: RouteLoading,
});

const PropostaDashboardAnalitico = Loadable({
  loader: () => import('../views/Proposta/Dashboard/Analitico'),
  loading: RouteLoading,
});

const AnaliseProposta = Loadable({
  loader: () => import('../views/Proposta/Analise'),
  loading: RouteLoading,
});

const Relatorios = Loadable({
  loader: () => import('../views/Proposta/Relatorios'),
  loading: RouteLoading,
});

const RelatorioCargaOnline = Loadable({
  loader: () => import('../views/Proposta/Relatorios/RelatorioCargaOnline'),
  loading: RouteLoading,
});

const RelatorioProcessosPrincipais = Loadable({
  loader: () => import('../views/Proposta/Relatorios/RelatorioProcessosPrincipais'),
  loading: RouteLoading,
});

const PropostaVisualizar = Loadable({
  loader: () => import('../views/Proposta/Visualizar'),
  loading: RouteLoading,
});

const PropostaPagamento = Loadable({
  loader: () => import('../views/Proposta/Pagamento'),
  loading: RouteLoading,
});

const FormChecagemLTLR = Loadable({
  loader: () => import('../views/Proposta/FormChecagemLTLR'),
  loading: RouteLoading,
});
const PropostaPreCadastro = Loadable({
  loader: () => import('../views/Proposta/PreCadastro'),
  loading: RouteLoading,
});

const ConsultaPonte = Loadable({
  loader: () => import('../views/Proposta/ConsultaPonte'),
  loading: RouteLoading,
});

const Pendencia = Loadable({
  loader: () => import('../views/Proposta/Pendencia'),
  loading: RouteLoading,
});

const SolicitacaoPonte = Loadable({
  loader: () => import('../views/Proposta/SolicitacaoPonte'),
  loading: RouteLoading,
});

const FormularioAvaliacao = Loadable({
  loader: () => import('../views/Proposta/FormularioAvaliacao'),
  loading: RouteLoading,
});

const AnalisePagamentoVisualizar = Loadable({
  loader: () => import('../views/Proposta/Analise/Visualizar'),
  loading: RouteLoading,
});

const RouteProposta = [
  {
    path: '/pre-pagamento/proposta',
    exact: true,
    name: 'Consulta de Proposta',
    component: PropostaIndex,
  },
  {
    path: '/pre-pagamento/dashboard',
    exact: true,
    name: 'Dashboard',
    component: PropostaDashboard,
  },
  {
    path: '/pre-pagamento/dashboard/analitico',
    exact: true,
    name: '',
    component: PropostaDashboardAnalitico,
  },
  {
    path: '/pre-pagamento/analise',
    exact: true,
    name: 'Análise de Proposta',
    component: AnaliseProposta,
  },
  {
    path: '/pre-pagamento/relatorios',
    exact: true,
    name: 'Relatórios',
    component: Relatorios,
  },
  {
    path: '/pre-pagamento/relatorios/carga-online',
    exact: true,
    name: 'Relatório de Carga On-line',
    component: RelatorioCargaOnline,
  },
  {
    path: '/pre-pagamento/relatorios/processos-principais',
    exact: true,
    name: 'Relatório de Processos Principais',
    component: RelatorioProcessosPrincipais,
  },
  {
    path: '/pre-pagamento/proposta/visualizar/:mode',
    exact: true,
    name: 'Visualizar Proposta',
    component: PropostaVisualizar,
  },
  {
    path: '/pre-pagamento/analise/visualizar/:mode',
    exact: true,
    name: 'Visualizar Proposta',
    component: AnalisePagamentoVisualizar,
  },
  {
    path: '/pre-pagamento/proposta/pagamento/:id',
    exact: true,
    name: 'Solicitação de Pagamento',
    component: PropostaPagamento,
  },
  {
    path: '/pre-pagamento/proposta/solicitacao-ponte/:id',
    exact: true,
    name: 'Solicitação de Ponte',
    component: SolicitacaoPonte,
  },
  {
    path: '/pre-pagamento/proposta/ponte/:idContrato',
    exact: true,
    name: 'Consulta de Ponte',
    component: ConsultaPonte,
  },
  {
    path: '/pre-pagamento/proposta/pendencia/:idContrato',
    exact: true,
    name: 'Inserir Pendência',
    component: Pendencia,
  },
  {
    path: '/pre-pagamento/proposta/checagemltlr/:id',
    exact: true,
    name: 'Checagem LT/LR',
    component: FormChecagemLTLR,
  },
  {
    path: '/pre-cadastro',
    exact: true,
    name: 'Pré-Cadastro de Proposta',
    component: PropostaPreCadastro,
  },
  {
    path: '/pre-pagamento/proposta/formulario-avaliacao-veiculo/:numeroProposta',
    exact: true,
    name: 'Formulário de Avaliação do Veículo',
    component: FormularioAvaliacao,
  },
];

export { RouteProposta };
